











































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common"
import moment from 'moment';
import http from "../../plugins/http";
import SumupTab from "../../components/SumupTab.vue";
import AlertArea from "../../components/AlertArea.vue";
import { Sheet, RowItem } from '../../modules/teacher/SumupMajorNoScoreRateList';

export interface Data {
  tabNo: number
  sheet_group_key: string
  sheet: Sheet | null
  roomNames: string[]
  rowItems: RowItem[]
  SheetTypeEnum: Readonly<{Normal: number; Cbt: number; Entrance: number}>
  errors: string[]
}

export default defineComponent({
  components: {
    "sumup-tab": SumupTab,
    "alert-area": AlertArea,
  },
  setup(props, context){

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      tabNo: 3,
      sheet_group_key: "",
      sheet: null,
      roomNames: new Array<string>(),
      rowItems: new Array<RowItem>(),
      SheetTypeEnum: Common.SheetTypeEnum,
      errors: [],
    });

    /************************************************************
     * グラフのclass取得
     ************************************************************/

    const getGraphClass = (idx: number, roomRate: number, totalRate: number) => {
      if(idx == 2){
        return {yoda: true};
      }else if(totalRate > roomRate + 10){
        return {pink: true};
      }else if(totalRate < roomRate - 10 ){
        return {obi: true};
      }else{
        return {yoda: true};
      }
    };

    const downloadExcel = () => {

      const param = {
        room_names: state.roomNames,
        rows: state.rowItems
      };

      http.post(`/api/teacher/sumup_major_no_correct_rate_list/download_excel/${state.sheet_group_key}`, param, {responseType: 'arraybuffer'}).then(response => {
        const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `saiten_result_${moment().format('Y-M-D')}.xlsx`;
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
    };

    /************************************************************
     * mounted
     ************************************************************/
    
    onMounted(async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.sheet_group_key = context.root.$route.params.sheet_group_key;
      await http.get(`/api/teacher/sumup_major_no_score_rate_list?sheet_group_key=${state.sheet_group_key}`).then(response => {
        
        state.sheet = new Sheet(response.data.sheet);
        const roomNames: string[] = Array.from(new Set(response.data.score_rates.map((x: any) => x.room_name)));
        state.roomNames.push("全体");
        state.roomNames = state.roomNames.concat(roomNames);

        const majorNos: string[] = Array.from(new Set(response.data.score_rates.map((x: any) => x.part1)));

        majorNos.forEach(majorNo => {
          const scoreRates = response.data.score_rates.filter((x: any) => x.part1 == majorNo);
          state.rowItems.push(new RowItem(scoreRates));
        });
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。`);
        }
        context.root.$store.dispatch("goSheetList");
      });
      context.root.$store.dispatch("hideOverlay");
    });

    return {
      ...toRefs(state),
      getGraphClass,
    };
  }
});

